enum DocumentTagTypeEnum {
    MENTION = 'mention',
    KEYWORD = 'keyword'
}

export default DocumentTagTypeEnum
